"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomJoi = void 0;
const joi_1 = __importDefault(require("joi"));
const sanitize_html_1 = __importDefault(require("sanitize-html"));
const htmlStrip = (joi) => ({
    type: 'string',
    base: joi.string(),
    messages: {
        'string.htmlStrip': '{{#label}} must not contain any html tags',
    },
    rules: {
        htmlStrip: {
            validate(value, helpers) {
                const clean = (0, sanitize_html_1.default)(value, {
                    allowedTags: [],
                    allowedAttributes: {},
                });
                if (clean === value) {
                    return clean;
                }
                return helpers.error('string.htmlStrip');
            },
        },
    },
});
exports.CustomJoi = joi_1.default.extend(htmlStrip);
//# sourceMappingURL=CustomJoi.js.map